import { useMemo } from 'react';
import { UseDataProps } from './types';
import { FieldDesc } from '90.quickConnect.Models/models';

/**
 * Hook qui détermine les dépendances d'une règle de visibilité
 * @param flattenFields
 * @returns
 */
const useData = (flattenFields: FieldDesc[]): UseDataProps => {
  const allHidableFields = useMemo(
    () =>
      // Inclure tous les champs avec règles de visibilité, même ceux avec desactivatedAutomation=true
      // pour permettre une évaluation initiale en mode consultation
      flattenFields.filter((v) => typeof v.visible !== 'boolean' && !!v.visible),
    [flattenFields],
  );

  return { allHidableFields };
};

export default useData;
